// app/javascript/controllers/nested_form_controller.js
import { Controller } from "@hotwired/stimulus";

// Generic nested form controller usable for each association group.
// Structure expected:
// <div data-controller="nested-form">
//   <template data-nested-form-target="template"> ... NEW_RECORD ... </template>
//   <div data-nested-form-target="target"> existing nested items </div>
//   <button data-action="nested-form#add">Add</button>
// </div>
// Each nested item wrapper must have class 'nested-form-wrapper' and include a hidden _destroy field.
export default class extends Controller {
    static targets = ["template", "target"]; // One template + one target per controller instance

    connect() {
        // Debug output to verify the controller is initialized
        // Remove or comment out later if not needed
        console.debug("[nested-form] controller connected", this.element);
    }

    add(event) {
        event.preventDefault();
        if (!this.hasTemplateTarget || !this.hasTargetTarget) return;
        const uniqueId = new Date().getTime();
        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, uniqueId);
        this.targetTarget.insertAdjacentHTML("beforeend", content);
            this.dispatchChanged();
    }

    remove(event) {
        event.preventDefault();
        const wrapper = event.target.closest(".nested-form-wrapper");
        if (!wrapper) return;
        const destroyInput = wrapper.querySelector("input[name*='[_destroy]']");
        if (destroyInput) {
            // Mark for destruction if record persisted
            if (destroyInput.value === "0" || destroyInput.value === "") {
                destroyInput.value = "1";
                wrapper.style.display = "none"; // hide instead of removing to allow Rails to process _destroy
            } else {
                // If already marked, just remove from DOM
                wrapper.remove();
            }
        } else {
            // No destroy field -> just remove
            wrapper.remove();
        }
            this.dispatchChanged();
    }

        dispatchChanged() {
            const event = new CustomEvent("nested-form:changed", { bubbles: true });
            this.element.dispatchEvent(event);
        }
}